//require('./src/globalization/external/angular-ui-i18n.min.js');
require('./src/blocks.i18n.module');
require('./src/globalization/globalization.module');
require('./src/globalization/components/globalization.interceptor.service');
require('./src/globalization/components/globalization.management.service');
require('./src/globalization/config/globalization.config');
require('./src/globalization/config/globalization.constant');
require('./src/globalization/config/globalization.run');
